"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exec = void 0; // Function to run multiple vendors in sequence

exports.exec = (vendors, featureFlags = []) => __awaiter(void 0, void 0, void 0, function* () {
  if (!vendors || !vendors.length) return featureFlags;
  const [vendor, ...rest] = vendors; // If one of the vendors in the chain throws, we catch and continue to process rest of values

  let features = featureFlags;

  try {
    features = yield vendor(featureFlags);
  } catch (e) {}

  const result = yield exports.exec(rest, features);
  return result;
});